import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageKeys, LocalStorageService } from '../data/local-storage.service';
import { Language, languageValues } from '@concretecode/shared';

export function langQueryParamInitializer(): () => void {
  return (): void => {
    const document = inject(DOCUMENT);
    const localStorageService = inject(LocalStorageService);

    const langParam = new URLSearchParams(document.location.search).get('lang');
    if (!langParam || !languageValues.includes(langParam as Language)) {
      return;
    }

    localStorageService.set(LocalStorageKeys.preferredLanguage, langParam);

    // removing lang query param from URL
    const url = new URL(document.location.href);
    url.searchParams.delete('lang');
    document.defaultView?.history.replaceState(document.defaultView.history.state, '', url.toString());
  };
}
